import type { BrandedIconProps } from './types';

/**
 * PIX logo — Banco Central do Brasil's instant payments mark.
 * Official brand color: `#32BCAD` (PIX teal).
 *
 * The mark is a square rotated 45° composed of four converging arrow
 * shapes. Path simplified from the BCB official SVG asset (public domain
 * per BCB's Manual de Marca PIX, available at
 * https://www.bcb.gov.br/estabilidadefinanceira/pix).
 */
export function PixIcon({
  size = 24,
  className,
  'aria-label': ariaLabel = 'PIX',
}: BrandedIconProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <path
        fill="#32BCAD"
        d="M18.266 17.91a3.962 3.962 0 0 1-2.815-1.166l-3.115-3.114a.781.781 0 0 0-1.067 0l-3.126 3.127a3.962 3.962 0 0 1-2.815 1.166h-.61l3.945 3.943a3.155 3.155 0 0 0 4.464 0l3.957-3.956h-.818Zm-12.96-12.06a3.962 3.962 0 0 1 2.815 1.167l3.126 3.127a.755.755 0 0 0 1.068 0l3.114-3.114A3.961 3.961 0 0 1 18.243 5.86h.5L14.789 1.91a3.156 3.156 0 0 0-4.464 0L6.388 5.85h-.083Z"
      />
      <path
        fill="#32BCAD"
        d="m21.764 9.768-2.391-2.39a.412.412 0 0 1-.151.03h-.97a2.808 2.808 0 0 0-1.972.819l-3.115 3.115a1.953 1.953 0 0 1-2.762 0L7.265 8.211a2.808 2.808 0 0 0-1.972-.817H4.115a.413.413 0 0 1-.143-.03L1.567 9.768a3.155 3.155 0 0 0 0 4.464l2.405 2.404a.41.41 0 0 1 .143-.029h1.178a2.81 2.81 0 0 0 1.972-.818l3.137-3.135a1.997 1.997 0 0 1 2.762 0l3.115 3.114a2.808 2.808 0 0 0 1.972.819h.97a.412.412 0 0 1 .151.029l2.392-2.39a3.155 3.155 0 0 0 0-4.465"
      />
    </svg>
  );
}
